import { Validators } from '@angular/forms';

export const EmailValidator = Validators.compose([
    Validators.maxLength(70),
    Validators.pattern(/^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
    Validators.required,
]);
